'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { DayPicker } from 'react-day-picker';
import { cn } from '../../utils';
import ArrowNarrowLeft from '../Icon/ArrowNarrowLeft';
import ArrowNarrowRight from '../Icon/ArrowNarrowRight';
function Calendar({ className, classNames, showOutsideDays = true, ...props }) {
    return (_jsx(DayPicker, { showOutsideDays: showOutsideDays, className: cn('p-3', className), classNames: {
            months: 'flex flex-col relative w-[252px]',
            month_caption: 'flex justify-center relative items-center',
            weekdays: 'flex flex-row',
            weekday: 'w-[36px] h-[34px] text-[12px] leading-[18px] font-semibold flex flex-col justify-center items-center text-[#6B7280]',
            month: 'gap-y-4 overflow-x-hidden',
            caption: 'flex justify-center pt-1 relative items-center',
            caption_label: 'text-sm font-medium truncate',
            nav: 'flex items-start justify-between absolute w-full h-[24px] z-10',
            month_grid: 'mt-4 w-[full]',
            week: 'flex w-full',
            day: 'p-0 size-8 text-sm flex-1 flex items-center justify-center has-[button]:hover:!bg-accent rounded-md has-[button]:hover:aria-selected:!bg-[#14532d] has-[button]:hover:text-accent-foreground has-[button]:hover:aria-selected:text-primary-foreground',
            range_start: 'day-range-start rounded-s-md bg-[#14532d] text-primary-foreground',
            range_end: 'day-range-end rounded-e-md bg-[#14532d]',
            selected: 'bg-[#14532d] text-primary-foreground hover:!bg-[#14532d] hover:text-primary-foreground focus:bg-[#14532d] focus:text-primary-foreground',
            today: 'text-accent-foreground',
            outside: 'day-outside text-muted-foreground opacity-50 aria-selected:text-muted-foreground aria-selected:opacity-100',
            disabled: 'pointer-events-none opacity-50 text-gray-400',
            range_middle: 'aria-selected:bg-accent hover:aria-selected:!bg-accent rounded-none aria-selected:text-accent-foreground hover:aria-selected:text-accent-foreground',
            hidden: 'pointer-events-none opacity-10',
            ...classNames,
        }, components: {
            PreviousMonthButton: ({ ...props }) => (_jsx("div", { className: "h-4 w-4 cursor-pointer", children: _jsx(ArrowNarrowLeft, { fill: "#111827" }) })),
            NextMonthButton: ({ ...props }) => (_jsx("div", { className: "h-4 w-4 cursor-pointer", children: _jsx(ArrowNarrowRight, { fill: "#111827" }) })),
        }, ...props }));
}
Calendar.displayName = 'Calendar';
export { Calendar };
